namespace TabAurous.Common {
    export enum OpeningBalanceType {
        Debit = 1,
        Credit = 2
    }
    Serenity.Decorators.registerEnumType(OpeningBalanceType, 'TabAurous.Common.OpeningBalanceType', 'Finance.OpeningBalanceType');
}
